import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { initFeatureFlagSuccess } from '@stores/features-flags/features-flags-ngrx.action';
import { loadServicesSuccess } from '@stores/services/services.action';
import { map } from 'rxjs';

export const initFeatureFlag = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(loadServicesSuccess),
      map((service) => service.service?.extras.featureFlags),
      map((featureFlags) => initFeatureFlagSuccess({ featureFlags }))
    ),
  { functional: true }
);
